import { DatabaseApiKeyService } from '@qdrant/qdrant-cloud-public-api/cluster/auth/v2';
import {
  listDatabaseApiKeys,
  createDatabaseApiKey,
  deleteDatabaseApiKey,
} from '@qdrant/qdrant-cloud-public-api/cluster/auth/v2/connect-query';
import { listCollections } from '@qdrant/qdrant-cloud-public-api/ui/v1/clusterdata/connect-query';
import { transport } from '@/api/transport';
import {
  createServiceQueries,
  queryOptions,
  type MutationFactory,
  useMutation,
  createConnectQueryKey,
} from '@/connect-query';

export const databaseApiKeyV2Service = createServiceQueries(DatabaseApiKeyService, {
  listDatabaseApiKeysQuery: (params) => queryOptions(listDatabaseApiKeys, params, { transport }),
});

export const useDeleteDatabaseApiKeyMutation: MutationFactory<typeof deleteDatabaseApiKey> = () =>
  useMutation(deleteDatabaseApiKey, {
    onSuccess: (_data, { accountId, clusterId }, _onMutateResult, { client }) =>
      Promise.all([
        client.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listDatabaseApiKeys,
            input: { accountId, clusterId },
          }),
        }),
        client.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listCollections,
            input: { accountId, clusterId },
          }),
        }),
      ]),
  });

export const useCreateDatabaseApiKeyMutation: MutationFactory<typeof createDatabaseApiKey> = () =>
  useMutation(createDatabaseApiKey, {
    onSuccess: (data, _vars, _onMutateResult, { client }) =>
      Promise.all([
        client.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listDatabaseApiKeys,
            input: { accountId: data.databaseApiKey?.accountId, clusterId: data.databaseApiKey?.clusterId },
          }),
        }),
        client.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listCollections,
            input: { accountId: data.databaseApiKey?.accountId, clusterId: data.databaseApiKey?.clusterId },
          }),
        }),
      ]),
  });
